var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegister(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35.629 49.425",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.155 26.98L4.933 1.292A2.57 2.57 0 003.229.65c-.359 0-.72.074-1.062.227A2.583 2.583 0 00.65 3.23v39.435a2.58 2.58 0 004.542 1.67l9.687-11.398 6.543 14.728c.283.734.916 1.11 1.572 1.11a1.721 1.721 0 001.57-2.418l-6.565-14.77h14.448a2.577 2.577 0 002.411-1.667c.285-1.007.103-2.135-.703-2.94h0zm-19.637 1.073L4.088 40.418V5.13L30.17 28.15H14.518v-.098z",
    fill: "#76DAE7",
    fillRule: "nonzero",
    stroke: "#3C3C3B",
    strokeWidth: 1.3
  })));
}
export default SvgRegister;